"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var tooltip_trigger_1 = __importDefault(require("./tooltip-trigger"));
var variables_1 = require("../../../styles/variables");
var AdaptedTooltip = (0, react_1.forwardRef)(function (_a, ref) {
    var className = _a.className, children = _a.children, props = __rest(_a, ["className", "children"]);
    return (react_1.default.createElement(material_1.Tooltip, __assign({}, props, { ref: ref, classes: { tooltip: className } }),
        react_1.default.createElement(material_1.Box, { display: "flex" }, children)));
});
AdaptedTooltip.displayName = "AdaptedTooltip";
var NwTooltip = (0, styles_1.styled)(AdaptedTooltip)(function (_a) {
    var theme = _a.theme;
    var fontFamily = theme.typography.fontFamily;
    return {
        backgroundColor: variables_1.colors["lime-tint-lp-2"],
        border: "1px solid #B1B3B5",
        borderRadius: 8,
        boxShadow: "0 4px 8px 0 rgb(100 102 106 / 15%), 0 8px 16px 0 rgb(100 102 106 / 33%)",
        color: "#000",
        fontFamily: fontFamily,
        fontSize: ".8125rem",
        fontWeight: "normal",
        lineHeight: "1.53846154",
        padding: "1rem 1rem 1rem 1rem",
        "& .MuiTooltip-arrow": {
            color: variables_1.colors["lime-tint-lp-2"],
        },
        "& .MuiTooltip-arrow::before": {
            backgroundColor: variables_1.colors["lime-tint-lp-2"],
            border: "1px solid #B1B3B5",
            boxSizing: "border-box",
        },
    };
});
var Tooltip = function (_a) {
    var _b = _a.position, position = _b === void 0 ? "top" : _b, text = _a.text, ariaLabel = _a.ariaLabel, _c = _a.maxWidth, maxWidth = _c === void 0 ? 374 : _c, trigger = _a.trigger, onOpen = _a.onOpen, onClose = _a.onClose, onBlur = _a.onBlur, isOpen = _a.isOpen, setIsOpen = _a.setIsOpen;
    var tooltipRef = (0, react_1.useRef)(null);
    var handleContainerClick = function (e) {
        e.stopPropagation();
    };
    if (!text) {
        return null;
    }
    return (react_1.default.createElement(material_1.ClickAwayListener, { onClickAway: function (e) {
            if (isOpen &&
                tooltipRef.current &&
                !tooltipRef.current.contains(e.target)) {
                setIsOpen(false);
                if (onBlur)
                    onBlur();
            }
        } },
        react_1.default.createElement(material_1.Box, { ref: tooltipRef, onClick: handleContainerClick, component: "span", display: "flex", alignItems: "center" },
            react_1.default.createElement(NwTooltip, { "aria-label": ariaLabel, title: text, placement: position, sx: { mx: 3, maxWidth: maxWidth }, arrow: true, open: isOpen },
                react_1.default.createElement(tooltip_trigger_1.default, { onTriggerToggle: function () {
                        if (!isOpen && onOpen) {
                            onOpen();
                        }
                        if (isOpen && onClose) {
                            onClose();
                        }
                        setIsOpen(!isOpen);
                    }, arialLabel: ariaLabel }, trigger)))));
};
exports.default = Tooltip;
